var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Portal',{attrs:{"selector":"#uiToastManager"}},[_c('transition-group',{class:[
      'UIElement',
      _vm.$style.ToastManager
    ],attrs:{"tag":"div"},on:{"before-enter":_vm.beforeEnter,"enter":_vm.enter,"leave":_vm.leave}},_vm._l((_vm.items),function(item,index){return _c('div',{key:item.id,class:_vm.$style.Toast,style:({
        transform: _vm.getItemTransform(index)
      }),attrs:{"data-index":index}},[_vm._v(" "+_vm._s(item.title)+" "),_c('Icon',{class:_vm.$style.Toast_icon,attrs:{"icon":"fal fa-times"},on:{"click":function($event){return _vm.removeItem(item)}}})],1)}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }